import * as React from "react";
import {Control, Field, Icon, Input} from "bloomer";
import Card from "../../../elements/Card";
import {getImageLabelingResult} from "../../../api/models/ImageLabeling";
import Button from "../../../elements/Button";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import ErrorUtils from "../../../utils/ErrorUtils";
import InputWarning from "../../../elements/InputWarning";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import SectionName from "../../../elements/SectionName";
import Spacer from "../../../elements/Spacer";
import InformationCard from "../../../elements/InformationCard";
import {toast} from "react-toastify";
import BeautifyDecimal from "../../../utils/BeautifyDecimal";
import {INVALID_FIELD_STYLE, URL_REGEX} from "../../../utils/Constants";

interface IImageLabelingModelState {
    loading: boolean;
    urlInput: string;
    urlInputEmpty: boolean;
    urlInputInvalid: boolean;
    result: any;
    errorMessage: string;
}

class ImageLabelingModel extends React.Component<{}, IImageLabelingModelState> {

    constructor(props: {}) {
        super(props);
        this.state = {
            loading: false,
            urlInput: "",
            urlInputEmpty: false,
            urlInputInvalid: false,
            result: [],
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.IMAGE_LABELING);
    }

    public handleURLInputChange = (e: any) => {
        const value = e.target.value;

        let urlInputEmpty = false;
        let valid = true;
        if (value.trim()) {
            valid = URL_REGEX.test(value.trim());
        } else {
            urlInputEmpty = true;
        }

        this.setState({
            urlInput: value,
            urlInputInvalid: !valid,
            urlInputEmpty,
            errorMessage: ""
        });
    };


    public onSubmit = async (e: any) => {
        e.target.blur();

        if (this.state.loading) {
            return;
        }

        if (this.state.loading || !this.state.urlInput.trim() || this.state.urlInputInvalid) {

            this.setState({result: []});

            if (!this.state.urlInput.trim()) {
                this.setState({
                    urlInputEmpty: true,
                    urlInputInvalid: false
                });
            }

            return;
        }

        this.setState({
            loading: true,
            result: [],
            errorMessage: ""
        });

        let errorOccurred = false;

        const formData = new FormData();
        formData.append("image_url", this.state.urlInput.trim());

        const response = await getImageLabelingResult(formData).catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Unable to process image."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data) {
            const result: any = [];
            const responseData = response.data;
            Object.keys(responseData).forEach((key) => {
                result.push({
                    label: key,
                    value: BeautifyDecimal(responseData[key])
                });
                result.sort((a: any, b: any) => {
                    return a.value < b.value ? 1 : -1;
                });
            });

            this.setState({
                loading: false,
                result
            });
        } else {
            this.setState({
                loading: false,
                errorMessage: "Unable to process image."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.IMAGE_LABELING);
    };

    public resetState = async (e: any) => {
        e.target.blur();

        this.setState({
            loading: false,
            urlInput: "",
            urlInputEmpty: false,
            urlInputInvalid: false,
            result: [],
            errorMessage: ""
        });
    };

    public render() {
        return (
            <ModelContentContainer>
                <Card>
                    <SectionName>Image URL</SectionName>
                    <Field>
                        <Control>
                            <Input
                                style={(this.state.urlInputEmpty || this.state.urlInputInvalid) ? INVALID_FIELD_STYLE : undefined}
                                type="text"
                                placeholder="Enter image url here"
                                value={this.state.urlInput}
                                onChange={this.handleURLInputChange}
                            />
                            <div>
                                {
                                    this.state.urlInputEmpty && <InputWarning>Please input URL.</InputWarning>
                                }
                                {
                                    this.state.urlInputInvalid &&
                                    <InputWarning>Please input a valid URL.</InputWarning>
                                }
                            </div>
                        </Control>
                    </Field>
                    <Spacer/>
                    {
                        this.state.urlInput && !this.state.urlInputInvalid && !this.state.urlInputEmpty ? <React.Fragment>
                            <img alt="Image" src={this.state.urlInput.trim()}/>
                            <Spacer/>
                        </React.Fragment> : <></>
                    }
                    <div>
                        <Button onClick={this.onSubmit}>Submit</Button>
                        <Button onClick={this.resetState} style={{marginLeft: "5px"}}>Reset</Button>
                    </div>
                    {
                        this.state.loading ? <div>
                            <Spacer/>
                            <span>Loading...</span>
                            <Icon className="fas fa-spinner fa-spin"/>
                        </div> : <></>
                    }
                    {
                        !this.state.loading && this.state.result && this.state.result.length ? <div>
                            <Spacer/>
                            <SectionName>Output:</SectionName>
                            <InformationCard>
                            {
                                this.state.result.map((item: any) => {
                                    return <p key={item.label} style={{marginLeft: '10px'}}>
                                        <span title="Label"><b>{item.label}</b></span>{" - "}<span title="Score">{item.value}</span>
                                    </p>;
                                })
                            }
                            </InformationCard>
                        </div> : <></>
                    }
                    {
                        this.state.errorMessage && !this.state.loading ? <div>
                            <Spacer/>
                            <InformationCard>{this.state.errorMessage}</InformationCard>
                        </div> : <></>
                    }
                </Card>
            </ModelContentContainer>
        );
    }
}

export default ImageLabelingModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/ImageLabeling/ImageLabelingModel.tsx